import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'lib/core/data/reducer'
import { ERROR } from 'lib/core/resources/constants'

export const getPayload = (state: RootState) => {
  return state.customer.createAccount.payload
}

export const getIsFetching = (state: any) => {
  return state.customer.createAccount.isFetching
}

export const getIsSuccess = (state: any) => {
  return state.customer.createAccount.isSuccess
}

export const getIsFailure = (state: any) => {
  return state.customer.createAccount.isFailure
}

export const getError = createSelector(
  getIsFailure,
  getPayload,
  (isFailure, payload) => {
    if (isFailure) {
      switch (payload?.message) {
        case ERROR.CUSTOMER_EXISTS:
          return 'customer.account.create.error.customerExists'

        default:
          return 'app.whoops'
      }
    }
  }
)
